import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserThemeRepositoryImpl } from "../../data/repository/user_theme_repository_impl";
import { FinishThemeInterface } from "../interface/finish_theme_interface";
import { UserThemeInterface } from "../interface/user_theme_interface";

export const useFinishTheme = () => {
  const repository = new UserThemeRepositoryImpl();
  const queryClient = useQueryClient();

  return useMutation<UserThemeInterface, Error, FinishThemeInterface>({
    mutationFn: (data: FinishThemeInterface) => repository.finishTheme(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userProfile'] });
    },
  });
};
